import { useContext } from 'react';
import { HeaderTop as PaletteHeaderTop } from 'palette/HeaderTop';
import { LANGUAGE_SELECT_MODAL_ID } from 'palette/LanguageSelector/constants';
import { ModalContext } from 'palette/Modal';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslation } from '@common/Hooks/useTranslation';
import { ReactOnRailsRootComponent } from '@common/ReactOnRails';
import StoreSelect from '@common/StoreSelect';
import { setNavFromValue } from '@common/Tracking/NavFrom';
import trackerAttributes from '@common/Tracking/NavFrom/constants/TrackedDataAttr';
import { trackEvent } from '@helpers/analytics';
import { parsePromoBarsData } from '../helpers/dataParser';

import '../styles/HeaderTop.scss';

function HeaderTop({
    customerServiceUrl,
    promoBarsDataV2,
    uspText,
    promoBarsData,
    stores,
    languages
}) {
    const translate = useTranslation();
    const { store, language } = useConfig();
    const { activeModalId } = useContext(ModalContext);
    const isLanguageModalOpen = activeModalId === LANGUAGE_SELECT_MODAL_ID;
    const { banners = [], activeId } = promoBarsData !== null ? parsePromoBarsData(promoBarsData) : {};

    const handlePreviousButtonClick = () => {
        trackEvent('paging', 'promo', 'previous');
    };

    const handleNextButtonClick = () => {
        trackEvent('paging', 'promo', 'next');
    };

    const handleMainLinkClick = (event) => {
        setNavFromValue(trackerAttributes.top_banner, event);
    };

    const handleExpandedLinkClick = (event) => {
        setNavFromValue(trackerAttributes.top_banner, event);
    };

    const ariaLabel = {
        languageSelectButton: translate('header.language_select.title'),
        leftArrowButton: translate('button.previous'),
        rightArrowButton: translate('button.next')
    };

    return (
        <PaletteHeaderTop
            activeLanguage={language}
            activeStore={store}
            ariaLabel={ariaLabel}
            banners={banners}
            customerServiceLink={{
                url: customerServiceUrl,
                label: translate('footer.customer_services.link')
            }}
            defaultId={activeId}
            languages={languages}
            languageSelectorSubTitle={translate('header.language_select.subtitle')}
            languageSelectorTitle={translate('header.language_select.title')}
            promoBarSlides={promoBarsDataV2}
            storeSelector={(
                <StoreSelect
                    preventOpen={isLanguageModalOpen}
                    stores={stores}
                />
            )}
            uspText={uspText}
            onExpandedLinkClick={handleExpandedLinkClick}
            onMainLinkClick={handleMainLinkClick}
            onNextBannerClick={handleNextButtonClick}
            onPreviousBannerClick={handlePreviousButtonClick}
        />
    );
}

export const HeaderTopStandalone = ReactOnRailsRootComponent(HeaderTop, { withReduxStore: false });
